import { defineStore } from 'pinia';
import TwilioVoiceClient from 'dashboard/api/channel/voice/twilioVoiceClient';
import { TERMINAL_STATUSES } from 'dashboard/helper/voice';
import whatsappCallingClient from 'dashboard/helper/whatsappCallingClient';

export const useCallsStore = defineStore('calls', {
  state: () => ({
    calls: [],
  }),

  getters: {
    activeCall: state => state.calls.find(call => call.isActive) || null,
    hasActiveCall: state => state.calls.some(call => call.isActive),
    incomingCalls: state => state.calls.filter(call => !call.isActive),
    hasIncomingCall: state => state.calls.some(call => !call.isActive),
  },

  actions: {
    handleCallStatusChanged({ callSid, status }) {
      if (TERMINAL_STATUSES.includes(status)) {
        this.removeCall(callSid);
        return;
      }

      this.calls = this.calls.map(call =>
        call.callSid === callSid ? { ...call, status } : call
      );
    },

    addCall(callData) {
      if (!callData?.callSid) return;
      const existingCall = this.calls.find(
        call => call.callSid === callData.callSid
      );
      if (existingCall) {
        this.calls = this.calls.map(call =>
          call.callSid === callData.callSid ? { ...call, ...callData } : call
        );
        return;
      }

      this.calls.push({
        ...callData,
        isActive: callData.isActive === true,
      });
    },

    removeCall(callSid) {
      const callToRemove = this.calls.find(c => c.callSid === callSid);
      if (callToRemove?.provider === 'whatsapp') {
        whatsappCallingClient.closeSession(callSid);
      } else if (callToRemove?.isActive) {
        TwilioVoiceClient.endClientCall();
      }
      this.calls = this.calls.filter(c => c.callSid !== callSid);
    },

    setCallActive(callSid) {
      this.calls = this.calls.map(call => ({
        ...call,
        isActive: call.callSid === callSid,
      }));
    },

    clearActiveCall() {
      const hasActiveNonWhatsappCall = this.calls.some(
        call => call.isActive && call.provider !== 'whatsapp'
      );
      if (hasActiveNonWhatsappCall) {
        TwilioVoiceClient.endClientCall();
      }
      this.calls
        .filter(call => call.isActive && call.provider === 'whatsapp')
        .forEach(call => whatsappCallingClient.closeSession(call.callSid));
      this.calls = this.calls.filter(call => !call.isActive);
    },

    dismissCall(callSid) {
      this.calls = this.calls.filter(call => call.callSid !== callSid);
    },
  },
});
